export default "__VITE_ASSET__ClX3eWdg__"